import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {Location} from "@angular/common";

@Component({
  selector: 'app-payment-procedure',
  templateUrl: './payment-procedure.component.html',
  styleUrls: ['./payment-procedure.component.scss']
})
export class PaymentProcedureComponent implements OnInit {
    currentPath: string;
    items = [
        {
           content: ''
        },
        {
            name: 'Axis Bank',
            logo: 'assets/img/bank-logos/axis.jpg',
            representative: {
                name: 'Ms. Neha Verma',
                mobile: '+91-9876504321'
            },
            emails: ['neha.verma@axisbank.com', 'studentloan@axisbank.com'],
            downloadLink: 'assets/documents/axis-loan-offer.pdf'
        },
        {
            name: 'IDFC First Bank',
            logo: 'assets/img/bank-logos/idfc.jpg',
            representative: {
                name: 'Mr. Karan Mehta',
                mobile: '+91-9988776655'
            },
            emails: ['karan.mehta@idfcfirstbank.com', 'support@idfcfirstbank.com'],
            downloadLink: 'assets/documents/idfc-loan-offer.pdf'
        },
        {
            name: 'Yes Bank',
            logo: 'assets/img/bank-logos/Yes_Bank_logo.png',
            representative: {
                name: 'Ms. Pooja Nair',
                mobile: '+91-9090909090'
            },
            emails: ['pooja.nair@yesbank.in', 'loanhelp@yesbank.in'],
            downloadLink: 'assets/documents/yesbank-loan-offer.pdf'
        },
        {
            name: 'Bank of Baroda',
            logo: 'assets/img/bank-logos/bob-logo.png',
            representative: {
                name: 'Mr. Rakesh Sinha',
                mobile: '+91-9123456789'
            },
            emails: ['rakesh.sinha@bankofbaroda.com', 'edu.support@bob.com'],
            downloadLink: 'assets/documents/bob-loan-offer.pdf'
        },
        {
            name: 'IDBI Bank',
            logo: 'assets/img/bank-logos/IDBI-Bank-logo.png',
            representative: {
                name: 'Ms. Swati Joshi',
                mobile: '+91-9988665544'
            },
            emails: ['swati.joshi@idbi.co.in', 'loans@idbi.co.in'],
            downloadLink: 'assets/documents/idbi-loan-offer.pdf'
        },
        {
            name: 'Propelld',
            logo: 'assets/img/bank-logos/propelld.png',
            representative: {
                name: 'Mr. Deepak Singh',
                mobile: '+91-9000001111'
            },
            emails: ['deepak.singh@propelled.in', 'info@propelled.in'],
            downloadLink: 'assets/documents/propelled-loan-offer.pdf'
        },
        {
            name: 'Bank of Maharashtra',
            logo: 'assets/img/bank-logos/Bank_of_Maharashtra_logo.svg.png',
            representative: {
                name: 'Ms. Anjali Patil',
                mobile: '+91-9012345678'
            },
            emails: ['anjali.patil@mahabank.com', 'loan@mahabank.com'],
            downloadLink: 'assets/documents/maha-loan-offer.pdf'
        }
    ];
    constructor(private router: Router,
                private location: Location) {
        this.currentPath = this.location.path();
    }

    isActive(path: string): boolean {
        return this.currentPath === path;
    }

  ngOnInit(): void {
  }

}
